import React from "react";
import { useNavigate } from "react-router-dom";
// import Chip from "@mui/material/Chip";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_PAGES,
  DELETE_PAGE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { EnhancedTableStatusCell } from "@vocollege/components";

export default function Pages() {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/pages/${id}`);
  };

  const getFilters = () => {
    return [
      {
        name: "status",
        label: I18n.get.form.labels.status,
        default: ["all"],
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          { label: I18n.get.status.published, value: "1" },
          { label: I18n.get.status.unpublished, value: "0" },
        ],
      },
      {
        name: "template",
        label: I18n.get.form.labels.template,
        default: ["all"],
        multiple: true,
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          ...Object.keys(I18n.get.page.templates).map((template: string) => ({
            label: I18n.get.page.templates[template],
            value: template,
          })),
        ],
      },
    ];
  };

  return (
    <Layout>
      <EnhancedTable
        // client={client}
        className="vo-global__top-bottom-space"
        enableSearch
        title={I18n.get.misc.pages}
        operations={{
          category: "pages",
          get: GET_PAGES,
          delete: DELETE_PAGE,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.form.labels.title, field: "title" },
          {
            title: I18n.get.form.labels.template,
            field: "template",
            render: (data) => I18n.get.page.templates[data?.template],
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data: any) => (
              <EnhancedTableStatusCell data={data.status} />
            ),
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        filters={getFilters()}
      />
    </Layout>
  );
}
